var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnlookFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 22,
    viewBox: "0 0 118 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9744 21.5H38.1354V1.0827H44.3249V15.6772H51.9744V21.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6771 21.5H29.4876C29.4876 21.5 26.1432 16.1873 25.4819 15.0302C25.4819 15.0302 25.4444 20.3305 25.4819 21.5H19.2924V1.07025H25.4819C25.8562 1.72968 29.3877 9.84186 29.4876 10.0285V1.07025H35.6771C35.6397 3.54621 35.6397 20.318 35.6771 21.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.834 21.5H10.7443L8.42322 7.67692L6.10216 21.5H0L3.28194 1.0329H13.5645L16.834 21.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118 21.5H109.29L103.699 15.9384V21.5H97.5098V1.09515H103.699V6.66916L109.29 1.09515H117.825L107.805 11.2976L118 21.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4327 10.4515C54.4327 12.8155 55.2813 15.1048 56.8162 16.9089C58.3511 18.713 60.485 19.9074 62.831 20.2807C65.177 20.6539 67.573 20.1811 69.5945 18.9494C71.6161 17.7176 73.1385 15.8016 73.8748 13.562C74.611 11.31 74.5237 8.87137 73.6252 6.68158C72.7267 4.49179 71.0795 2.6877 68.9706 1.60524C66.8617 0.522791 64.4408 0.224185 62.1322 0.75919C59.8236 1.2942 57.7895 2.63793 56.3794 4.54156L64.4033 10.4391H54.4327V10.4515Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0514 10.4515C95.0514 12.8155 94.2028 15.1048 92.6679 16.9089C91.1331 18.713 88.9992 19.9074 86.6532 20.2807C84.3071 20.6539 81.9112 20.1811 79.8896 18.9494C77.868 17.7176 76.3456 15.8016 75.6094 13.562C74.8731 11.31 74.9605 8.87137 75.8589 6.68158C76.7574 4.49179 78.4046 2.6877 80.5136 1.60524C82.6225 0.522791 85.0434 0.224185 87.352 0.75919C89.6606 1.2942 91.6946 2.63793 93.1047 4.54156L85.0808 10.4391H95.0514V10.4515Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7483 15.2542L77.8805 18.3771L74.7483 21.5L71.6161 18.3771L74.7483 15.2542Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnlookFull);
export default __webpack_public_path__ + "static/media/Anlook_full.e64dfbd5fd462332216da0eaf23e0229.svg";
export { ForwardRef as ReactComponent };